<template>
  <div id="app">
    <div class="header">
      <van-nav-bar title="" left-text="返回" @click-left="backJump" left-arrow>
        <template #right>
          <van-icon name="ellipsis" />
        </template>
      </van-nav-bar>
    </div>
    <div class="search">
      <input class="inpu" type="text" v-model="phone" placeholder="请输入住户手机号">
      <van-button icon="search" type="primary" @click="searchCon">搜索</van-button>
    </div>
    <div class="foot" v-if="show">
      <p>请选择您要绑定的住户：</p>
      <van-cell-group inset v-for="item in content" style="margin-top: 20px;border:1px solid #dee1e5;padding: 5px;border-radius: 15px;font-family: '黑体'" >
        <van-cell title="用户名称：" :value="item.name" style="margin-top: 5px" />
        <van-cell title="用户地址：" :value="item.address" style="margin-top: 5px"/>
        <van-button type="warning" @click="unbindHouse(item)" v-if="item.id == personCon.houseId" style="border-radius: 20px">
          解除绑定
        </van-button>
        <van-button type="primary" @click="bindHouse(item)" v-else style="background-color:#1989fa;float: right;border-radius: 20px">
          确认绑定
        </van-button>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import {bindHouse, phoneHouse, unbindHouse} from "../common/api/room";
import jump from "../common/jump";

export default {
  name: "default",
  data(){
    return{
      phone:'',
      content:[],
      show:false,
      personCon:[]
    }
  },
  mounted() {
    console.log(this.$route.query)
    this.personCon = this.$route.query
  },
  methods:{

    backJump(){
      this.$destroy()
      jump.$emit('back')
      this.$router.go(-1)
    },
    searchCon(){
      console.log("查询")
      console.log(this.phone)
      if(this.phone == ""){
        return
      }
      phoneHouse({phone:this.phone}).then( res => {
        this.show = true
        this.content = res.data
      })
    },
    bindHouse(row){
      console.log(row)
      bindHouse(row).then( res =>{
        console.log(res)
        this.$toast.success(res.msg)
        if(res.code == '200'){
          this.personCon.houseId = row.id
          this.searchCon()
        }
      })
    },
    unbindHouse(item){
      this.$dialog.confirm({
        title: '',
        message: '确认取消绑定住户吗',
        showCancelButton: true
      })
          .then(async() => {
            unbindHouse().then(res => {
              this.$toast.success(res.msg)
              if(res.code == '200'){
                this.personCon.houseId = ''
                this.searchCon()
              }
            })
          })
          .catch(() => { // 点击取消按钮后的调用
            console.log('点击了取消按钮噢')
          })

    }
  }
}
</script>

<style scoped>
.inpu{
  background-color: #EAEAEA ;
  border: none;
  border-radius: 20px;
  /*height: 28px;*/
  font-size: 12px;
  padding: 10px;
  letter-spacing: 1px;
  font-family: '黑体';
  float: left;
  width: 59%;
  margin-left: 10px;
  margin-top:10px
}
.search .van-button {
  float: right;
  margin-right: 10px;
  background-color: #5B8DFD ;
  border-radius: 20px;
  margin-top:10px
}
.van-button--normal{
  width:30%;
}
/*.foot .van-button{*/
/*  background-color:#1989fa;*/
/*}*/
.foot{
  width:90%;
  margin:50px auto;
  background-color: #fff;
  border-radius: 10px;
}

</style>